import React from "react";
import { Fab, Tooltip } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/useAuth";
import FeedbackDialog from "./FeedbackDialog";

export default function FeedbackButton() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = React.useState(false);

  if (!isAuthenticated) return null;

  return (
    <>
      <Tooltip title={t("feedback.button_tooltip", "Donner mon avis")}>
        <Fab
          color="primary"
          size="medium"
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1200,
            bgcolor: "#6366f1",
            "&:hover": { bgcolor: "#4f46e5" },
          }}
        >
          <ChatBubbleOutlineIcon />
        </Fab>
      </Tooltip>
      <FeedbackDialog open={open} onClose={() => setOpen(false)} context="general" />
    </>
  );
}
